import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { xorBy } from 'lodash'

import { AddNewProgramFormModel } from '../../AddNewProgram.types'
import { FieldSection } from '../../formSection/fieldSection/FieldSection'

import { Checkbox } from '@percent/lemonade'
import {
  RelationshipTypeValues,
  RelationshipValues
} from '@percent/admin-dashboard/app/validations/nonprofitDetail/relatedOrganisations/RelatedOrganisations.types'
import { DisallowedOrganisation } from '@percent/admin-dashboard/api/actions/validationSubmissions/validationSubmissions.types'

export function DisallowedOrganisations() {
  const { t } = useTranslation()

  const { setValue, control } = useFormContext<AddNewProgramFormModel>()

  const [disallowedOrganisations] = useWatch({
    control,
    name: ['disallowedOrganisations']
  })

  const onDisallowedOrganisationChange = (disallowedOrganisation: DisallowedOrganisation) =>
    setValue(
      'disallowedOrganisations',
      xorBy(disallowedOrganisations || [], [disallowedOrganisation], item => `${item.type}_${item.relationship}`),
      { shouldValidate: true, shouldDirty: true }
    )

  return (
    <FieldSection title={t('form.disallowedOrganizations')}>
      <Checkbox
        variant="default"
        active={disallowedOrganisations?.some(
          item =>
            item.type === RelationshipTypeValues.FISCAL_SPONSORSHIP && item.relationship === RelationshipValues.CHILD
        )}
        name="fiscalSponsorshipChild"
        label={t('form.fiscalSponsorshipChild')}
        onChange={() =>
          onDisallowedOrganisationChange({
            type: RelationshipTypeValues.FISCAL_SPONSORSHIP,
            relationship: RelationshipValues.CHILD
          })
        }
      />
      <Checkbox
        variant="default"
        active={disallowedOrganisations?.some(
          item =>
            item.type === RelationshipTypeValues.FISCAL_SPONSORSHIP && item.relationship === RelationshipValues.PARENT
        )}
        name="fiscalSponsorshipParent"
        label={t('form.fiscalSponsorshipParent')}
        onChange={() =>
          onDisallowedOrganisationChange({
            type: RelationshipTypeValues.FISCAL_SPONSORSHIP,
            relationship: RelationshipValues.PARENT
          })
        }
      />
      <Checkbox
        variant="default"
        active={disallowedOrganisations?.some(
          item => item.type === RelationshipTypeValues.BRANCH && item.relationship === RelationshipValues.CHILD
        )}
        name="branchChild"
        label={t('form.branchChild')}
        onChange={() =>
          onDisallowedOrganisationChange({
            type: RelationshipTypeValues.BRANCH,
            relationship: RelationshipValues.CHILD
          })
        }
      />
      <Checkbox
        variant="default"
        active={disallowedOrganisations?.some(
          item => item.type === RelationshipTypeValues.BRANCH && item.relationship === RelationshipValues.PARENT
        )}
        name="branchParent"
        label={t('form.branchParent')}
        onChange={() =>
          onDisallowedOrganisationChange({
            type: RelationshipTypeValues.BRANCH,
            relationship: RelationshipValues.PARENT
          })
        }
      />
    </FieldSection>
  )
}
